module.exports = __webpack_public_path__ + "static/media/withoutpaper.1419f306.png";